import { questionTypes } from 'sharedParts';
import triggerOptionValues from './postLogicTriggerValues';

const isLabel = 'equal to';

const decorateOptionText = (option) => ({
  ...option,
  label: option.label === isLabel ? 'Select option is' : `Select option is ${option.label}`,
});

const rawDefaultTriggerOptions = [
  {
    label: isLabel,
    value: triggerOptionValues.equal,
  },
];

export const defaultTriggerOptions = rawDefaultTriggerOptions.map(decorateOptionText);

export const rawScaleTriggerOptions = [
  {
    label: 'less than or equal to',
    value: triggerOptionValues.lessOrEqual,
  },
  {
    label: 'greater than or equal to',
    value: triggerOptionValues.greaterOrEqual,
  },
  {
    label: 'less than',
    value: triggerOptionValues.less,
  },
  {
    label: 'greater than',
    value: triggerOptionValues.greater,
  },
  ...rawDefaultTriggerOptions,
];

const scaleTriggerOptions = rawScaleTriggerOptions.map(decorateOptionText);

const rawTriggerOptions = {
  [questionTypes.questionScale]: rawScaleTriggerOptions,
  [questionTypes.questionNumeric]: rawScaleTriggerOptions,
};

const triggerOptions = {
  [questionTypes.questionScale]: scaleTriggerOptions,
  [questionTypes.questionNumeric]: scaleTriggerOptions,
};

export default triggerOptions;

export const getQuestionTypeTriggerOptions = (questionType, decorated) => {
  return decorated
    ? triggerOptions[questionType] || defaultTriggerOptions
    : rawTriggerOptions[questionType] || rawDefaultTriggerOptions;
};
